import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './Utility.css'
// import {Row, Col} from 'react-flexbox-grid'
// import config from '../../config'
// import { Link } from '../'

@CSSModules(Styles,{allowMultiple:false})
class ContainerDivs extends Component {
  render() {
    return(
       <div styleName='c'>
         <div styleName='ci'>
          {this.props.children}
        </div>
      </div>
    )
  }
}

@CSSModules(Styles,{allowMultiple:false})
class SrOnly extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return(
       <span styleName='sr-only'>
        {this.props.children}
      </span>
    )
  }
}

@CSSModules(Styles,{allowMultiple:false})
class XsBr extends Component {
  render() {
    return(
       <br styleName='visible-xs'/>
    )
  }
}

@CSSModules(Styles,{allowMultiple:false})
class LinkIcon extends Component {
  static propTypes = {
    nospace: PropTypes.bool,
    faclass: PropTypes.string,
  }
  constructor(props){
    super(props)
  }

  render(){
    const nospace = this.props.nospace || false
    const faclass = this.props.faclass || 'fa-angle-double-right'
    return (
      <span>
        <i
          styleName={ nospace ? null : 'space-left' }
          className={ 'fa ' + faclass }
        />
      </span>
    )
  }
}

@CSSModules(Styles)
export default class YesNo extends Component {
  static propTypes = {
    yes: PropTypes.bool.isRequired,
  }
  constructor(props){
    super(props);
  }
  render() {
    return (
      <i
        styleName={this.props.yes ? 'yes':'no'}
        className={'fa '+( this.props.yes ? 'fa-check-circle' : 'fa-times' )}
      />
    )
  }
}

export {
  ContainerDivs,
  SrOnly,
  XsBr,
  LinkIcon,
  YesNo
}